import request from '@/plugins/request';
import utils from '@/utils';
import { AxiosResponse } from 'axios';
import { IBoolResult } from '@/types/dto';
import { auth } from '@/store';

const $url = '/logout';

export default {
  logout(redirect = '/') {
    utils.loading(true);

    request
      .post($url)
      .then((response: AxiosResponse<IBoolResult>) => {
        if (!response.data.value) return;

        auth.logout();
        if (utils.isAbsoluteUrl(redirect)) {
          window.location.href = redirect;
        } else {
          utils.pageOpen('login', { redirect });
        }
      })
      .catch(error => {
        utils.error(error, true);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
